<div class="home-bg">
  <div>
    <div class="row m-0 p-3" id="topSec">
      <div class="col-12">
        <alert class="alert-position"></alert>
      </div>
      <div class="col header-col">
        <img class="bankLogo" src="../../assets/img/logo/logo-blue.svg" alt="Logo">
        <div class="log-out-menu c-pointer">
          <a (click)=logOut()>
            <label class="fa fa-power-off"></label>
          </a>
        </div>
      </div>
    </div>
    <div class="row m-0" *ngIf="giftCards?.length > 1" [style.height.px]="midSecHt">
      <div class="col-12 mt-0 h-100">
        <div class="hm-tb-wrpr h-100">
          <div>
            <h3 class="cardHrader">
              Here are your cards
            </h3>
          </div>
          <div>
            <div class="row justify-content-center compBg wrpr-comp-bg" infiniteScroll [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="100" (scrolled)="onScroll()" [scrollWindow]="false">
              <div class="col-12">
                <div class="mb-2 card-container" *ngFor="let card of giftCards; let i = index;">
                  <div class="cardBg ml-auto mr-auto pl-4 c-pointer"
                    [ngStyle]="{'background-color': card?.imageBackgroundColorCode}" (click)="viewCardDetail(card)">
                    <div class="txnSec-spinner" *ngIf="card.show!=true">
                      <div class="txnSec-inner pl-0">
                        <span class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </span>
                      </div> 
                    </div>
                    <img src="{{card?.imageUrl}}" [ngClass]="{'card-image-visible' : card?.show}" class="card-image" (load)="card.show=true">
                    <div class="status" [ngStyle]="{'background-color':getstatusBg(card)}">{{card?.giftCardStatus}}</div>
                    <h1 class="cardNumber" [ngStyle]="{'color':card.imageTextColorCode}">{{card?.decryptedMaskedCardNo}}</h1>
                    <h2 class="expDate" [ngStyle]="{'color':card.imageTextColorCode}"><span class="vld-thr">VALID THRU</span>
                      <div>
                        <div class="mh-ye">MONTH/YEAR</div>
                        <div class="mh-ye-txt">{{card.expDate || 'MM/YY'}}</div>
                      </div>
                    </h2>
                    <h2 class="cardUserName" [ngStyle]="{'color':card.imageTextColorCode}">{{card?.beneficiaryName}}</h2>
                    <span class="cardDisplayName"
                      [ngStyle]="{'color':card.imageTextColorCode}">{{card?.decryptedCardDisplayName}}</span>
                  </div>
                  <div class="balanceText">Available Balance : <span class="card-currency">₹ </span>
                    <span class="card-balance">{{card?.decryptedCurrentBalance?.toLocaleString('en-IN')}}</span></div>
                </div>
                <div class="txnSec-spinner" *ngIf="isLoading">
                  <div class="txnSec-inner pl-0">
                    <span class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </span>
                  </div>
                </div>
                <div class="mb-2 mt-2" style="padding: 25px 0px 0px 25px !important;">
                  <div class="txnSec-bdr" *ngIf="giftCards?.length === totalItems">
                    <div class="txnSec-inner-notext">
                      <span>{{noMoreCardText}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="txnSec-spinner" *ngIf="!giftCards?.length">
      <div class="txnSec-inner pl-0">
        <span class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </span>
      </div>
    </div>
  </div>
</div>
